<template>
  <div>
    <vx-card>
      <ListUsers :subjectPermission="subjectPermission"></ListUsers>
    </vx-card>
  </div>
</template>

<script>
import ListUsers from "./../../lists/ListUsers";

export default {
  data() {
    return {
      subjectPermission: "Usuário",
    };
  },
  methods: {},
  components: {
    ListUsers,
  },
};
</script>
